<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" :fill="svgColor">
        <g :clip-path="`url(#${clipId})`">
            <path :fill="backgroundColor" d="M.704.444h13.333v11.111H.704z"/>
            <path :fill="checkColor" d="M5.33 6.838S3.468 4.441 2.053 4.815.697 6.406.707 6.538c.048.573 1.402 1.42 2.4 2.576 1.096 1.272 1.561 2.465 2.434 2.438s1.11-.573 1.345-1.298C7.122 9.53 8.371 6.91 9.27 5.688s3.282-3.564 4.152-4.144c.752-.5.637-.749.567-.924s-.376-.273-.895-.05c-.52.222-4.127 2.046-5.896 3.992C5.43 6.508 5.334 6.835 5.334 6.835z"/>
        </g>
            <defs>
                <clipPath :id="clipId"><path :fill="backgroundColor" d="M.704.444h13.333v11.111H.704z"/></clipPath>
            </defs></svg>
</template>

<script setup>
import { useId } from 'vue'

const clipId = useId()
    defineProps({
        svgColor: {
            type: String,
            default: 'none'
        },
        backgroundColor: {
            type: String,
            default: '#fff'
        },
        checkColor: {
            type: String,
            default: '#577c32'
        }
        // #FA9F42 (orange)
        // #577c32 (gruen)
    })
</script>